import TabPage from "./../factories/tab-page";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialog from "./../factories/translate-dialog";

class CompressionType extends BaseViewModel {
    Name1 = ko.observable();
    Name2 = ko.observable();
    Name3 = ko.observable();
    Name4 = ko.observable();
    Name5 = ko.observable();
    Name = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Name1();
                case 2:
                    return this.Name2();
                case 3:
                    return this.Name3();
                case 4:
                    return this.Name4();
                case 5:
                    return this.Name5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Name1(value);
                    break;
                case 2:
                    this.Name2(value);
                    break;
                case 3:
                    this.Name3(value);
                    break;
                case 4:
                    this.Name4(value);
                    break;
                case 5:
                    this.Name5(value);
                    break;
            }
        }
    });

    public TranslateListName = function () {
        var translateDialog = new TranslateDialog(this.Name1, this.Name2, this.Name3, this.Name4, this.Name5);
        translateDialog.Open().then(function () {
        });
    };
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.Name() === "" || this.Name() === null) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "CompressionType/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init();
    }
}
export default CompressionType;